import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * The back arrow at the top-left of a detail page. Always browser history, never a fixed
 * destination: these pages are reached from a list, a search, a link someone pasted, or a sibling
 * record, and stepping back is what returns you to whichever of those it actually was — with the
 * list's filters and scroll position intact.
 */
export const BackButton: FC<{ label: string; className?: string }> = ({ label, className = '' }) => {
    const navigate = useNavigate();
    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            aria-label={label}
            className={`shrink-0 cursor-pointer ${className}`}
        >
            <ArrowLeft className="h-5 w-5" />
        </Button>
    );
};
